module.exports = __webpack_public_path__ + "img/weber_metallbearbeitung_strahltechnik_02.d9b12a18.jpg";